import React, { Component } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/opacity.css';
import Layout from './../layouts/Index';
import {renderMoqAttributes} from "../../utils/index";
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col, Container, ListGroup, Button, Modal, Placeholder } from 'react-bootstrap';
import { showOrder } from './../../store/actions/OrderActions';
import { FaGavel, FaCommentDots, FaEdit } from "react-icons/fa";

class Show extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      remarksModal: false,
      selectedOrder: undefined, // used to show remarks for a specific order (if needed)
    };
  }

  componentDidMount = async () => {
    const { match: { params } } = this.props;
    this.setState({ loading: true });

    const result = await this.props.showOrder(params.id);
    if (result) {
      this.setState({ loading: false });
    }
  };

  // arrow fn to keep `this` bound
  toggleRemarksModal = (order) => {
    this.setState((prev) => ({
      remarksModal: !prev.remarksModal,
      selectedOrder: order !== undefined ? order : prev.selectedOrder,
    }));
  };

  render() {
    const order = this.props.orders?.order ?? {};
    const { history } = this.props;
    const { loading } = this.state;

    // small helper checks
    const hasMoq = Array.isArray(order?.moq) && order.moq.length > 0;
    const hasProduct = Array.isArray(order?.product) && order.product.length > 0;
    const hasProductImage = hasProduct && Array.isArray(order.product[0].images) && order.product[0].images.length > 0;

    // placeholder button style to mimic small buttons
    const placeholderBtnStyle = { height: 32, borderRadius: 6 };

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: '80vh', padding: '1.5em 0' }}>
          <Container>
            <Row>
              {/* Header */}
              <Col 
                sm="12"
                className="d-flex justify-content-between align-items-center mb-3"
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", marginBottom: "1em", }}>
                  {loading ? (
                      <Placeholder as="h3" animation="wave">
                          <Placeholder xs={4} />
                      </Placeholder>
                  ) : (
                      <div>
                        <h3 style={{ marginBottom: "0.25em" }}>Order #{order.order_number ?? '—'}</h3>
                        {hasMoq && (
                          <a
                            href={`https://litudian.s3.amazonaws.com/litudian_order_report_${order.order_number}_${order.moq[0].moq_number}.csv`}
                            target="_blank"
                            rel="noopener noreferrer"
                            download={`litudian_order_report_${order.order_number}_${order.moq[0].moq_number}.csv`}
                            style={{ fontSize: "1rem", color: "#007bff" }}
                          >
                            Download Report
                          </a>
                        )}
                      </div>
                  )}
              </Col>

              {/* Image Column */}
              <Col sm="4" className="mb-3 d-flex align-items-stretch">
                {loading ? (
                    <Placeholder
                        as="div"
                        animation="wave"
                        className="w-100 h-100"
                        style={{ minHeight: "400px" }}
                    >
                      <Placeholder xs={4} className="h-100 w-100" />
                    </Placeholder>
                ) : (
                  hasProductImage ? (
                      <LazyLoadImage
                        src={order.product[0].images[0]}
                        alt={order.product[0].name || 'Product'}
                        effect="opacity"
                        style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "400px",
                            objectFit: "cover",
                            borderRadius: "0.25rem",
                            transition: "opacity 0.5s ease-in-out", // optional extra smoothness
                        }}
                      />
                  ) : (
                      <Placeholder
                          as="div"
                          animation="wave"
                          className="w-100 h-100"
                          style={{ minHeight: "400px" }}
                      >
                        <Placeholder xs={4} className="h-100 w-100" />
                      </Placeholder>
                  )
                )}
              </Col>

              {/* Content Column */}
              <Col sm="8" style={{ marginBottom: '1em' }}>
                {loading ? (
                  <ListGroup>
                    {[...Array(7)].map((_, idx) => (
                      <ListGroup.Item key={idx}>
                        <Placeholder as="p" animation="wave">
                          <Placeholder xs={7} /> <Placeholder xs={4} />
                        </Placeholder>
                      </ListGroup.Item>
                    ))}

                    {/* Placeholder buttons that match small button height */}
                    <ListGroup.Item className="d-flex gap-2">
                      <Placeholder.Button variant="success" xs={3} style={placeholderBtnStyle} />
                      <Placeholder.Button variant="warning" xs={3} style={placeholderBtnStyle} />
                      <Placeholder.Button variant="primary" xs={3} style={placeholderBtnStyle} />
                    </ListGroup.Item>
                  </ListGroup>
                ) : (
                  <ListGroup>
                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Product Name: </span>
                      <span>
                        {hasProduct ? order.product[0].name : 'N/A'} (
                        {hasMoq ? (
                          <Link to={`/admin/moqs/${order.moq[0].id}`}>{order.moq[0].moq_number}</Link>
                        ) : 'N/A'}
                        )
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Order Number: </span> <span>{order.order_number}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Date Created: </span>
                      <span>
                        {order.date_created
                          ? new Date(order.date_created).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            })
                          : 'N/A'}
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Supplier: </span>
                      <span>{Array.isArray(order?.supplier) && order.supplier.length > 0 ? order.supplier[0].name : 'N/A'}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Total Collected: </span>
                      <span>KES {order.total_collected?.toLocaleString() ?? '0'}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Shipping Mode: </span>
                      <span>{order.shipping ?? 'N/A'}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Total Shipping Fee: </span>
                      <span>KES {order.shipping_fee?.toLocaleString() ?? '0'}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Status: </span> <span>{order.status ?? 'N/A'}</span>
                    </ListGroup.Item>

                    {order.status !== "Order Deleted" && (
                      <ListGroup.Item>
                        <span style={{ fontWeight: 'bold' }}>ETA: </span>
                        <span>
                          {order.eta
                            ? new Date(order.eta).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              })
                            : 'N/A'}
                        </span>
                      </ListGroup.Item>
                    )}

                    {order.status === "Goods arrived at Litudian - Ready to collect" && (
                      <ListGroup.Item>
                        <span style={{ fontWeight: 'bold' }}>Date Arrived: </span>
                        <span>
                          {order.date_goods_arrived
                            ? new Date(order.date_goods_arrived).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              })
                            : 'N/A'}
                        </span>
                      </ListGroup.Item>
                    )}

                    <ListGroup.Item>
                      <span style={{ fontWeight: 'bold' }}>Shipping Fees: </span>
                      <div style={{ marginTop: '0.5em' }}>
                        {hasMoq && renderMoqAttributes(order.moq[0].moq_attributes)}
                      </div>
                    </ListGroup.Item>

                    {/* Action Buttons (real) */}
                    <ListGroup.Item className="d-flex gap-2">
                      {hasMoq && (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => history.push(`/admin/moqs/${order.moq[0].id}/bids`)}
                        >
                          <FaGavel className="me-1" /> View Bids
                        </Button>
                      )}

                      {order.remarks && (
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() => this.toggleRemarksModal(order)}
                        >
                          <FaCommentDots className="me-1" /> View Remarks
                        </Button>
                      )}

                      {order.status !== "Goods arrived at Litudian - Ready to collect" &&
                        order.status !== "Order Deleted" && (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => history.push(`/admin/orders/${order.id}/edit`)}
                          >
                            <FaEdit className="me-1" /> Edit PO
                          </Button>
                        )}
                    </ListGroup.Item>
                  </ListGroup>
                )}
              </Col>
            </Row>
          </Container>
        </Col>

        {/* Order Remarks Modal */}
        <Modal show={this.state.remarksModal} onHide={() => this.toggleRemarksModal()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Order {order.order_number ?? ''} Remarks</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {Array.isArray((this.state.selectedOrder ?? order)?.remarks) &&
            (this.state.selectedOrder ?? order).remarks.length > 0 ? (
              (this.state.selectedOrder ?? order).remarks.map((remark, idx) => {
                const creator = remark.creator_name || "Unknown";
                const date = remark.date_created
                  ? new Date(remark.date_created).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "N/A";

                const time = remark.date_created
                  ? new Date(remark.date_created).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "";

                return (
                  <p key={idx} style={{ textTransform: "capitalize" }}>
                    {remark.remarks} — by <span>{creator} on {date} {time}</span>
                  </p>
                );
              })
            ) : (
              <div>No remarks</div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.toggleRemarksModal()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.orders,
});

export default connect(mapStateToProps, { showOrder })(withRouter(Show));
